import { styles } from "./PageQuotations.style";
import { chain } from "lodash";

import * as React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { push } from "connected-react-router";

import { Typography, WithStyles, withStyles } from "@material-ui/core";

import { User } from "../../models/User.model";
import { RootState } from "../../types/RootState";

import QuotationsList from "../../components/QuotationsList/QuotationsList";
import { Customer } from "../../types/Customer";
import { PageConnected } from "../Page/Page";
import { Quotation } from "../../types/Quotation";
import { ActionHistory } from "../../types/ActionHistory";
import { setCustomerQuotation } from "../../store/actions";

import { values } from "lodash";

type PageQuotationsProps = {
    advisor: User;
    setCustomerQuotation: typeof setCustomerQuotation;
    customers: { [customerId: string]: Customer };
    push();
};

class PageQuotations extends React.Component<PageQuotationsProps & WithStyles<typeof styles>> {

    public onActionPerformed(quotation: Quotation, actionHistory: ActionHistory, customerId: string) {
        if ( !quotation.actionHistory ) {
            quotation.actionHistory = [];
        }
        quotation.actionHistory.push(actionHistory);
        this.props.setCustomerQuotation({ customerId, quotation});
    }

    public render() {

        const { classes, customers, advisor } = this.props;
        
        const quotationsList = chain(customers)
            .values()
            .map(c => values(c.quotations).map(q => ({
                quotation: q,
                customer: c
            })))
            .flatten()
            .sortBy((a) => { return new Date(a.quotation.creationDate); })
            .value();

        return (
            <PageConnected>
                <Typography className={classes.title} variant="display1">Propositions et Adhésions</Typography>
                <div className={classes.table}>
                    {quotationsList.length > 0 ? ( 
                    <QuotationsList
                        advisor={advisor}
                        displayHead={true}
                        quotationsList={quotationsList}
                        onActionPerformed={this.onActionPerformed.bind(this)}
                    />
                    ) : (
                    <Typography variant="body1">Vous n'avez pas encore de propositions ni d'adhésions.</Typography>
                    )
                    }
                </div>
            </PageConnected>
        );
    }

}

export const PageQuotationsConnected = compose(
    withStyles(styles),
    connect(
        (state: RootState, ownProps: any) => ({
            ...ownProps,
            advisor: state.me.user,
            customers: state.me.userData ? state.me.userData.customers : {}
        }),
        { push, setCustomerQuotation }
    )
)(PageQuotations);

// For stories
export const PageQuotationsStyled = withStyles(styles)(PageQuotations);



// WEBPACK FOOTER //
// ./src/pages/PageQuotations/PageQuotations.tsx